import React, { useEffect } from "react";
import { useParams } from "react-router-dom";


// icons 
import land_tax from '../../images/liaison/micro-landing/Icons/land_tax.png'
import town_survey from '../../images/liaison/micro-landing/Icons/town_survey.png'
import property_tax from '../../images/liaison/micro-landing/Icons/property_tax.png'
import drawing_analysis from '../../images/liaison/micro-landing/Icons/drawing_analysis.png'
import documentation from '../../images/liaison/micro-landing/Icons/documentation.png'
import drawing_iteration from '../../images/liaison/micro-landing/Icons/drawing_iteration.png'
import online_submission from '../../images/liaison/micro-landing/Icons/online_submission.png'
import coordination_dtcp from '../../images/liaison/micro-landing/Icons/coordination_dtcp.png'
import localbody_coordination from '../../images/liaison/micro-landing/Icons/localbody_coordination.png'
import approval_submission from "../../images/liaison/micro-landing/approval&submission.png"
import approval_documents from '../../images/liaison/micro-landing/Icons/approval_documents.png'
import validity_verification from '../../images/liaison/micro-landing/Icons/validity_verification.png'
import delivery from '../../images/liaison/micro-landing/Icons/delivery.png'
import land_use from '../../images/liaison/micro-landing/Icons/land_use.png'
import hillarea from '../../images/liaison/micro-landing/Icons/hillarea.png'
import hindrance from '../../images/liaison/micro-landing/Icons/hindrance.png'
import drawing_preparation from '../../images/liaison/micro-landing/Icons/drawing_preparation.png'
import undertaking_noc from '../../images/liaison/micro-landing/Icons/undertaking_noc.png'
import road_analysis from "../../images/liaison/micro-landing/Icons/road_analysis.png"
import pleader from '../../images/liaison/micro-landing/Icons/pleader.png'




function Liaison_ProcessFlow() {


    let params = useParams();
    const path = params.micro_id;

    let data = {

        dtcp: {
            feasibility: [
                {
                    image: land_tax,
                    heading: "Vacant Land Tax",
                    content: "Assessment of Vacant land tax payment history"
                },
                {
                    image: town_survey,
                    heading: "Town Survey land register verification",
                    content: "Assessment of Town Survey land register of the land parcel"
                },
                {
                    image: property_tax,
                    heading: "Property Tax verification",
                    content: "Assessment of Property tax payment history"
                },
            ],

            filepreparation: [
                {
                    image: drawing_analysis,
                    heading: "Drawing Analysis",
                    content: "Assessment of building Plan in accordance with Government regulations."
                },
                {
                    image: documentation,
                    heading: "Documentation",
                    content: "Creating a File of documents with all the required criteria for submission to DTCP."
                },
                {
                    image: drawing_iteration,
                    heading: "Drawing Iteration ",
                    content: "Altering the Drawing based on queries raised from DTCP"
                },
            ],

            submission: [
                {
                    image: online_submission,
                    heading: "Online & Offline Submissions",
                    content: "Submission of the file in the Government’s online portal"
                },

                {
                    image: coordination_dtcp,
                    heading: "Coordination with DTCP",
                    content: "Follow up with DTCP officials to address queries and get the File approved"
                },
                {
                    image: localbody_coordination,
                    heading: "Local body coordination",
                    content: "Follow up with Corporation officials to address queries and get the final approval"
                },
            ],
            approval: [
                {
                    image: approval_documents,
                    heading: "Approval Documents",
                    content: "Obtaining the approval File of Documents in form of Order copy"
                },

                {
                    image: validity_verification,
                    heading: "Validity & Verification",
                    content: "Ensuring validity and its future opportunities if there is a delay in execution"
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the Order copy as physical and soft copy"
                },
            ],
        },

        landuse: {
            feasibility: [
                {
                    image: land_use,
                    heading: "Land use Analysis",
                    content: "Expert analysis of the land usage as per the set norms of the Government"
                },
                {
                    image: hillarea,
                    heading: "Hill area Analysis",
                    content: "Analyzing the land parcel’s proximity to a Hill area"
                },
                {
                    image: hindrance,
                    heading: "Hindrance Verification",
                    content: "Assessing if the land parcel is free from hindrances listed by the Government"
                },
            ],

            filepreparation: [
                {
                    image: drawing_preparation,
                    heading: "Drawing preparation",
                    content: "Creating an accurate site drawing for the land parcel"
                },
                {
                    image: undertaking_noc,
                    heading: "Undertakings & NOC",
                    content: "Obtaining the required NOC from the applicable Government department"
                },

            ],

            submission: [
                {
                    image: online_submission,
                    heading: "Coordination with NOC Departments",
                    content: "Follow up with officials from respected Government departments to get the NOC"
                },

                {
                    image: coordination_dtcp,
                    heading: "Coordination with DTCP",
                    content: "Follow up with DTCP officials to address queries and get the File approved"
                },
                {
                    image: localbody_coordination,
                    heading: "Local body coordination",
                    content: "Follow up with Corporation officials to address queries and get the final approval"
                },
            ],
            approval: [
                {
                    image: approval_documents,
                    heading: "Approval Documents",
                    content: "Obtaining the approval File of Documents in form of Order copy"
                },

                {
                    image: validity_verification,
                    heading: "Validity & Verification",
                    content: "Ensuring validity and its future opportunities if there is a delay in execution"
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the Order copy as physical and soft copy"
                },
            ],
        },

        layoutapproval: {
            feasibility: [
                {
                    image: land_use,
                    heading: "Land use Analysis",
                    content: "Expert analysis of the land usage as per the set norms of the Government"
                },
                {
                    image: road_analysis,
                    heading: "Approach road Analysis",
                    content: "Analyzing the land parcel’s proximity to a Hill area"
                },
                {
                    image: hindrance,
                    heading: "Hindrance Verification",
                    content: "Assessing if the land parcel is free from hindrances listed by the Government"
                },
            ],

            filepreparation: [
                {
                    image: drawing_preparation,
                    heading: "Drawing Preparation",
                    content: "Creating an accurate Layout plan with maximum saleable area"
                },
                {
                    image: pleader,
                    heading: "Government Pleader Opinion",
                    content: "Obtaining an Opinion from the Government pleader for the Layout Documents"
                },
                {
                    image: undertaking_noc,
                    heading: "Documentation",
                    content: "Creating a File of documents with all the required criteria for submission to DTCP"
                },
            ],

            submission: [
                {
                    image: online_submission,
                    heading: "Online & Offline Submissions",
                    content: "Submission of the file in the Government’s online portal"
                },

                {
                    image: drawing_iteration,
                    heading: "Drawing Iteration",
                    content: "Follow up with DTCP officials to address queries and get the File approved"
                },
                {
                    image: undertaking_noc,
                    heading: "Follow up & Coordination",
                    content: "Follow up with Corporation officials to address queries and get the final approval"
                },
            ],
            approval: [
                {
                    image: approval_documents,
                    heading: "Approval Documents",
                    content: "Obtaining the approval File of Documents in form of Order copy"
                },

                {
                    image: validity_verification,
                    heading: "Validity & Verification",
                    content: "Ensuring validity and its future opportunities if there is a delay in execution"
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the Order copy as physical and soft copy"
                },
            ],
        },

        hacanoc: {
            feasibility: [
                {
                    image: land_use,
                    heading: "Land use Analysis",
                    content: "Expert analysis of the land usage as per the set norms of the Government"
                },
                {
                    image: road_analysis,
                    heading: "Approach road Analysis",
                    content: "Analyzing the land parcel’s proximity to a Hill area"
                },
            ],

            filepreparation: [

                {
                    image: drawing_iteration,
                    heading: "Drawing Preparation",
                    content: "Creating an accurate Layout plan with maximum saleable area"
                },
                {
                    image: pleader,
                    heading: "Government Pleader Opinion",
                    content: "Obtaining an Opinion from the Government pleader for the Layout Documents"
                },
            ],

            submission: [
                {
                    image: online_submission,
                    heading: "Online & Offline Submissions",
                    content: "Submission of the File to the respective online portals and Government offices"
                },

                {
                    image: coordination_dtcp,
                    heading: "Iteration",
                    content: "Alteration of the FIle based on the queries from respective Government bodies"
                },
                {
                    image: localbody_coordination,
                    heading: "Follow up & Coordination",
                    content: "Follow up with respective Government bodies to address queries and get the final approval"
                },
            ],
            approval: [
                {
                    image: approval_documents,
                    heading: "Approval Documents",
                    content: "Obtaining the approval File of Documents in form of Order copy"
                },

                {
                    image: validity_verification,
                    heading: "Validity & Verification",
                    content: "Ensuring validity and its future opportunities if there is a delay in execution"
                },
                {
                    image: delivery,
                    heading: "Delivery",
                    content: "Delivery of the Order copy as physical and soft copy"
                },
            ],
        },
    }

    return (
        <>

            {/* Feasibility card */}

            <div className="my-[90px]">
                <div className="my-[20px]">
                    <h2 className="heading" data-aos="fade-up">Feasibility Study</h2>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                </div>
                {/* flex flex-wrap justify-center gap-x-[70px] */}
                <div className="w-fit mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-flow-col justify-between gap-x-[70px] gap-y-12 my-[90px] px-4">
                    {
                        data[path].feasibility.map((items) => {

                            return (

                                <div className="w-[350px] mx-auto sm:mx-0" data-aos="fade-up" >
                                    <img className="w-[80px]" src={items.image} alt="icons" />
                                    <h1 className="font-noto max-w-[320px] text-[26px] font-bold leading-[40px] text-[#17212B] mt-[30px] sm:text-[30px] lg:mt-[40px]">{items.heading}</h1>
                                    <p className="font-alibaba max-w-[320px] text-[18px] sm:text-[20px] leading-[30px] text-[#5F5D5E] mt-[25px]">{items.content}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>


            {/* File preparation */}

            <div className="my-[90px] bg-grey py-[90px]">
                <div className="my-[20px]">
                    <h2 className="heading" data-aos="fade-up">File preparation</h2>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800" />
                </div>

                <div className="w-fit mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-flow-col justify-between gap-x-[70px] gap-y-12 my-[90px] px-4">
                    {
                        data[path].filepreparation.map((items) => {

                            return (

                                <div className="w-[350px] mx-auto lg:mx-0" data-aos="fade-up" >
                                    <img className="w-[80px]" src={items.image} alt="icons" />
                                    <h1 className="font-noto max-w-[320px] text-[26px] font-bold leading-[40px] text-[#17212B] mt-[30px] sm:text-[30px] lg:mt-[40px]">{items.heading}</h1>
                                    <p className="font-alibaba max-w-[320px] text-[18px] sm:text-[20px] leading-[30px] text-[#5F5D5E] mt-[25px]">{items.content}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>


            {/* Submission & coordination */}

            <div className="my-[90px]">
                <div className="my-[20px] px-4">
                    <h2 className="heading" data-aos="fade-up">Submission & coordination</h2>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800" />
                </div>

                <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-12 mt-[90px] px-4">
                    {
                        data[path].submission.map((items) => {

                            return (

                                <div className="w-[350px] mx-auto" data-aos="fade-up" >
                                    <img className="w-[80px]" src={items.image} alt="icons" />
                                    <h1 className="font-noto max-w-[320px] text-[26px] font-bold leading-[40px] text-[#17212B] mt-[30px] sm:text-[30px] lg:mt-[40px]">{items.heading}</h1>
                                    <p className="font-alibaba max-w-[320px] text-[18px] sm:text-[20px] leading-[30px] text-[#5F5D5E] mt-[25px]">{items.content}</p>
                                </div>
                            )
                        })
                    }
                </div>

                <img className="w-full object-cover" src={approval_submission} alt="Approval & Submission " />
            </div>

            {/* Approval & Delivery */}

            <div className="lg:py-[40px]">

                <div className="my-[20px]">
                    <h2 className="heading" data-aos="fade-up">Approval & delivery</h2>
                    <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800" />
                </div>

                <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-12 my-[90px] px-4">
                    {
                        data[path].approval.map((items) => {

                            return (

                                <div className="w-[350px] mx-auto" data-aos="fade-up" >
                                    <img className="w-[80px]" src={items.image} alt="icons" />
                                    <h1 className="font-noto max-w-[300px] text-[26px] font-bold leading-[40px] text-[#17212B] mt-[30px] sm:text-[30px] lg:mt-[40px]">{items.heading}</h1>
                                    <p className="font-alibaba max-w-[290px] text-[18px] sm:text-[20px] leading-[30px] text-[#5F5D5E] mt-[25px]">{items.content}</p>
                                </div>
                            )
                        })
                    }
                </div>

            </div>

        </>
    )
}

export default Liaison_ProcessFlow